import { Typography } from "@mui/material";
import { getClient } from "entity/LaudoVisita/components/LaudoVisitaConsultaRelatorios/functions";
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ReferenceLine, XAxis, YAxis } from "recharts";
import _ from 'lodash'

export default function LCGraficoExtraPainel({ indicadorProps, nomeAgrupador }) {
    let grupo = indicadorProps.mediaAgrupadorList[0]

    // obtém média de adultas e verifica o status
    let mediaAdultas = _.meanBy(grupo.apontamentos, (a) => parseFloat(_.get(a, 'numAdultasMetro', 0)))
    grupo.mediaAdultas = mediaAdultas.toFixed(2) // conformidade adultas por metro
    if (indicadorProps.paramsCliente) { // status e cor adultas por metro
        grupo.statusAdultas = indicadorProps.IndicadorClass.constructor.getConformidadeStatus(mediaAdultas, indicadorProps.paramsCliente.metaMaxAdultas, null, getClient())
        grupo.colorAdultas = indicadorProps.IndicadorClass.constructor.getColorStatus(grupo.statusAdultas)
    }

    return (
        <>
            <BarChart
                width={450}
                height={350}
                data={
                    indicadorProps.mediaAgrupadorList.map(barra => (
                        {
                            name: barra.groupNameShow, // texto abaixo da barra do gráfico
                            valor: barra.mediaAdultas
                        }
                    ))
                }
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis
                    // altura do gráfico de zero até a (maior média + 5 porcento dela), isso deixa o gráfico um pouco maior que a maior barra
                    domain={[
                        0,
                        (Math.max(...indicadorProps.mediaAgrupadorList.map(item => item.mediaAdultas)) + Math.max(...indicadorProps.mediaAgrupadorList.map(item => item.mediaAdultas)) * 0.05)
                    ]}
                />
                <ReferenceLine
                    // linha pontilhada marcando a meta
                    y={indicadorProps.paramsCliente?.metaMaxAdultas}
                    stroke="blue"
                    strokeDasharray="3 3"
                    label={{ value: '', position: 'left' }}
                />
                <Bar
                    dataKey="valor"
                    radius={[10, 10, 0, 0]}
                >
                    {indicadorProps.mediaAgrupadorList.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.colorAdultas} />)}
                    <LabelList
                        dataKey="valor"
                        position='top'
                        fill="#000"
                        fontWeight="bold"
                    />
                </Bar>
            </BarChart>
            {
                indicadorProps && indicadorProps.paramsCliente && indicadorProps.paramsCliente.metaMaxAdultas
                    ? (
                        <Typography
                            sx={{ textAlign: 'center', fontFamily: 'sans-serif' }}
                            variant={'subtitle1'}
                        >
                            Meta Adultas: {indicadorProps.paramsCliente.metaMaxAdultas}
                        </Typography>
                    )
                    : <></>
            }
            <Typography sx={{ textAlign: 'center', fontFamily: 'sans-serif' }} variant={'caption'}>por {nomeAgrupador}</Typography>
        </>
    )
}